import React, { useEffect, useState } from 'react';
import { Card, Table, Button, Space, Input, message, Popconfirm, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import weworkGroupWelcomeTemplateService from '../services/weworkGroupWelcomeTemplateService';

const WeworkGroupWelcomeTemplates = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [keyword, setKeyword] = useState('');
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);

  const load = async () => {
    setLoading(true);
    try {
      const res = await weworkGroupWelcomeTemplateService.list({ keyword, page: page - 1, size });
      if (res.success) {
        setData(res.data || []);
        setTotal(res.total || 0);
      } else {
        message.error(res.message || '加载失败');
      }
    } catch (e) {
      message.error(e.message || '加载失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [page, size]);

  const summarizeContent = (record) => {
    // 优先顶层字段
    const topText = typeof record?.textContent === 'string' ? record.textContent : '';
    const topAtt = Array.isArray(record?.attachments) ? record.attachments[0] : null;
    if (topText || topAtt) {
      const text = topText || '';
      let suffix = '';
      const att = topAtt;
      if (att) {
        if (att.type === 'IMAGE_GROUP') suffix = '[图片]';
        else if (att.type === 'LINK') suffix = '[链接]';
        else if (att.type === 'MINIPROGRAM') suffix = '[小程序]';
        else if (att.type === 'FILE') suffix = '[文件]';
        else if (att.type === 'VIDEO') suffix = '[视频]';
      }
      return `${(text || '').slice(0, 32)}${suffix}`;
    }
    const c = record?.content || {};
    const text = c.text?.content || '';
    if (c.image) return `${(text || '').slice(0, 32)}[图片]`;
    if (c.link) return `${(text || '').slice(0, 32)}[链接]`;
    if (c.miniprogram) return `${(text || '').slice(0, 32)}[小程序]`;
    if (c.file) return `${(text || '').slice(0, 32)}[文件]`;
    if (c.video) return `${(text || '').slice(0, 32)}[视频]`;
    return (text || '').slice(0, 32);
  };

  const columns = [
    { title: '名称', dataIndex: 'name' },
    { title: '内容', render: (_, r) => summarizeContent(r) },
    { title: '创建时间', dataIndex: 'createdAt' },
    {
      title: '操作',
      render: (_, record) => (
        <Space>
          <Button size="small" type="link" onClick={() => navigate(`/wework-group-welcome-templates/${record.id}`)}>编辑</Button>
          <Popconfirm title="确定删除?" onConfirm={async () => {
            try {
              const res = await weworkGroupWelcomeTemplateService.remove(record.id);
              if (res.success) { message.success('删除成功'); load(); } else { message.error(res.message || '删除失败'); }
            } catch (e) { message.error(e.message || '删除失败'); }
          }}>
            <Button size="small" danger type="link">删除</Button>
          </Popconfirm>
        </Space>
      )
    }
  ];

  return (
    <>
      <div style={{ marginBottom: 16 }}>
        <Typography.Title level={5} style={{ margin: 0 }}>入群欢迎语素材</Typography.Title>
      </div>
      <Card>
        <div style={{ marginBottom: 16 }}>
          <Input.Search enterButton placeholder="搜索名称" onSearch={() => { load(); }} allowClear value={keyword} onChange={e => setKeyword(e.target.value)} style={{ width: 260 }} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/wework-group-welcome-templates/create')}>新增</Button>
        </div>
        <Table
          rowKey="id"
          loading={loading}
          columns={columns}
          dataSource={data}
          pagination={{ current: page, pageSize: size, total, showSizeChanger: true, onChange: setPage, onShowSizeChange: (_, s) => { setSize(s); setPage(1); } }}
        />
      </Card>
    </>
  );
};

export default WeworkGroupWelcomeTemplates;


